import { render, staticRenderFns } from "./PrayerRequest.vue?vue&type=template&id=703dcf36&scoped=true&"
import script from "./PrayerRequest.vue?vue&type=script&lang=js&"
export * from "./PrayerRequest.vue?vue&type=script&lang=js&"
import style0 from "./PrayerRequest.vue?vue&type=style&index=0&id=703dcf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703dcf36",
  null
  
)

export default component.exports